module.exports = __webpack_public_path__ + "img/home_active.00754623.png";